import { Content } from '@backstage/core-components';
import { PageShareTitle } from '../../lib/shareTitle';
import { EntityContentBlueprint } from '@backstage/plugin-catalog-react/alpha';
import { getStoredFunMode, translate } from '../i18n';

/**
 * Kafka config + consumer-lag tab for kafka-topic API entities.
 * Shown only for API entities whose spec.type is "kafka-topic".
 * Extension id: entity-content:kafka/topic.
 */
export const topicKafkaContent = EntityContentBlueprint.make({
  name: 'topic',
  params: {
    path: '/kafka',
    // Non-component config (evaluated once at extension registration), so
    // this reads the fun-mode flag directly instead of the useT() hook — see
    // the i18n module's non-component-code note. "Kafka" is a brand name, so
    // its `en`/`fun` values are identical either way.
    title: translate('kafka.topicKafkaContent.title', getStoredFunMode()),
    filter: {
      kind: 'api',
      'spec.type': 'kafka-topic',
    },
    loader: () =>
      import('./TopicKafkaCard').then(m => (
        <PageShareTitle title="Kafka topic">
          <Content>
            <m.TopicKafkaCard />
          </Content>
        </PageShareTitle>
      )),
  },
});
